module.exports = __webpack_public_path__ + "static/images/1c0570d675c53a46a43a30315a4d9a33.webp";